import { FC, forwardRef } from 'react';
import { styled, Theme } from '@mui/material/styles';
import MUIRadio, { RadioProps } from '@mui/material/Radio';

const Icon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 22,
    height: 22,
    boxShadow:
        theme.palette.mode === 'dark'
            ? '0 0 0 1px rgb(16 22 26 / 40%)'
            : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background:
            theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
    '.MuiRadio-root': {
        backgroundImage: 'radial-gradient(#ffffff,#ffffff 28%,transparent 32%)',
    },
}));

const CheckedIcon = styled(Icon)(({ theme, disabled, readOnly }: { theme?: Theme, disabled: boolean, readOnly: boolean }) => ({
    backgroundColor: '#137cbd',
    cursor: readOnly ? "initial" : "pointer",
    backgroundImage: 'linear-gradient(180deg,#ffffff,#ffffff)',
    '&:before': {
        display: 'block',
        width: 25,
        height: 25,
        backgroundImage: disabled ? 'radial-gradient(#ffffff,#ffffff 28%,transparent 32%)' : 'radial-gradient(#1a73e8,#1a73e8 28%,transparent 32%)',
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        left: 0,
        margin: "auto",
        bottom: 0,
        padding: 0,
    },
})
);

const Radio = forwardRef<HTMLButtonElement, RadioProps>(
    ({ ...props }, ref) => (
        <MUIRadio
            ref={ref}
            {...props}
            disableRipple
            color="default"
            icon={<Icon />}
            checkedIcon={<CheckedIcon disabled={props.disabled || false} readOnly={props.readOnly || false} />}
            sx={props.disabled ? {
                "&:after": {
                    backgroundImage: 'radial-gradient(#ffffff,#ffffff 28%,transparent 32%)',
                }
            } : undefined}
        />
    )
);

export default Radio